import React, { Component, Fragment } from "react";
import Breadcrumb from "../../../common/breadcrumb";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import Datatable from "./monthData";
import "../invoice/wholesale-kido.css";
import { Link } from "react-router-dom";
import { User, ArrowLeft } from "react-feather";
import { Tabs, TabList, TabPanel, Tab } from "react-tabs";
import {
  getAllEmployeeRedux,
  getAllSourcingMonthStatsRedux,
  ensureCurrentMonthStatsRedux,
} from "../../../../actions/index";

import { connect } from "react-redux";

export class SoldMonth extends Component {
  componentDidMount = async () => {
    await this.props.ensureCurrentMonthStatsRedux();
    this.props.getAllSourcingMonthStatsRedux();
  };

  getMonthName = () => {
    const monthNames = [
      "January", "February", "March", "April", "May", "June", "July",
      "August", "September", "October", "November", "December",
    ];
    const d = new Date();
    return `${monthNames[d.getMonth()]},${d.getFullYear()}`;
  };

  render() {
    const { agentMonthStats } = this.props;
    const agent = this.props.match.params.agent;
    const all = agentMonthStats || [];
    const sum = (key) => all.reduce((s, m) => s + Number(m[key] || 0), 0);
    const tk = (v) => `৳ ${Math.round(v).toLocaleString("en-IN")}`;
    const stats = [
      { label: "Invoices", value: sum("invoiceCount").toLocaleString(), tone: "sky" },
      { label: "Billed", value: tk(sum("totalBill")), tone: "butter" },
      { label: "Agent profit", value: tk(sum("totalAgentProfit")), tone: "peach" },
      { label: "KIDO profit", value: tk(sum("totalZapaiProfit")), tone: "lilac" },
    ];

    return (
      <div className="kd-ws">
        <Breadcrumb title="Monthly" parent="Wholesale Management/ Order" />
        <div className="container-fluid">
          <section className="card kd-orders-card">
            <div className="kd-ord-top">
              <div className="kd-ord-title">
                <span className="kd-ord-title-tile kd-st--peach" aria-hidden="true">
                  <User size={20} />
                </span>
                <div>
                  <h2>{agent}</h2>
                  <svg className="kd-squiggle" viewBox="0 0 120 10" aria-hidden="true" focusable="false">
                    <path d="M2 6 Q12 1 22 6 T42 6 T62 6 T82 6 T102 6 T118 5" />
                  </svg>
                </div>
              </div>
              <div className="kd-ws-actions">
                <Link
                  to={`${process.env.PUBLIC_URL}/business-consultancy/sourcing-invoice-agents`}
                  className="btn btn-light"
                >
                  <ArrowLeft size={15} aria-hidden="true" />
                  All agents
                </Link>
              </div>
            </div>

            {all.length > 0 && (
              <div className="kd-ord-summary">
                <div className="kd-ord-stats kd-ws-stats">
                  {stats.map(({ label, value, tone }, i) => (
                    <div key={label} className={`kd-stat-tag kd-st--${tone}`} style={{ "--i": i }}>
                      <span className="kd-stat-label">{label}</span>
                      <span className="kd-stat-value">{value}</span>
                    </div>
                  ))}
                </div>
                <p className="kd-ws-scope">All months together</p>
              </div>
            )}

            <div className="kd-ws-body" id="basicScenario">
              <Datatable
                history={this.props.history}
                myData={agentMonthStats}
                agent={agent}
                currentMonth={this.getMonthName()}
              />
            </div>
          </section>
        </div>
        <ToastContainer />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const agent = ownProps.match.params.agent;
  return {
    allEmployees: state.employees.employees.filter(
      (employee) => employee.status == "Active"
    ),
    agentMonthStats: state.sourcings.monthStats
      .filter((month) => month.byAgent && month.byAgent[agent])
      .map((month) => ({ month: month.month, ...month.byAgent[agent] })),
  };
};

export default connect(mapStateToProps, {
  getAllEmployeeRedux,
  getAllSourcingMonthStatsRedux,
  ensureCurrentMonthStatsRedux,
})(SoldMonth);
